import styled from "styled-components";
import { Card } from "reactstrap";
const SpecialCard = styled(Card)`
  border: 1px solid #5a2d91;
`;

export default SpecialCard;
